<template>
  <div>
    <div class="tabs">
      <!-- <div class="tab-item" :class="index === 0 ? 'active' : ''" @click="tapFn(0)">
        销售数据看板
      </div> -->
      <div class="tab-item" :class="index === 3 ? 'active' : ''" @click="tapFn(3)">
        业绩看板
      </div>
      <div class="tab-item" :class="index === 1 ? 'active' : ''" @click="tapFn(1)">
        个人赛参赛数据总览
      </div>
      <div class="tab-item" :class="index === 2 ? 'active' : ''" @click="tapFn(2)">
        个人赛考量申请
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'EmptyComponent',
  props: {
    index: {
      type: Number
    }
  },
  data () {
    return {
    }
  },
  methods: {
    tapFn (index) {
      this.$emit('tap', index)
    }
  }
}
</script>

<style lang="less" scoped>
.tabs{
  display: flex;
  align-items: flex-end;
  .tab-item{
    width: 200px;
    height: 36px;
    border-radius: 14px 14px 0 0;
    color: #000;
    background-color: #fff;
    font-size: 14px;
    margin-right: 2px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .logo{
    width: 28px;
    height: 28px;
    margin-right: 4px;
    object-fit: contain;
    display: none;
  }
  .active{
    background-color: #FAD54A;
    height: 44px;
    font-weight: bold;
    font-size: 16px;
    .logo{
      display: block;
    }
  }
}
</style>
